// @ts-nocheck
/**
 * WI Variant Metafield
 *
 * Swaps the visible variant-metafield content based on the currently selected variant.
 *
 */

import { ThemeEvents } from '@theme/events';

class WIVariantMetafield extends HTMLElement {
  #content = null;
  #onVariantUpdateBound = null;

  connectedCallback() {
    this.#content = this.querySelector('.wi-variant-metafield__content');
    this.#onVariantUpdateBound = this.#onVariantUpdate.bind(this);
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdateBound);
  }

  disconnectedCallback() {
    if (this.#onVariantUpdateBound) {
      document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdateBound);
    }
  }

  #onVariantUpdate(event) {
    const variantId = event?.detail?.resource?.id;
    if (variantId == null || !this.#content) return;

    let active = null;
    this.#content.querySelectorAll('[data-variant-id]').forEach((panel) => {
      const match = String(panel.dataset.variantId) === String(variantId);
      panel.hidden = !match;
      if (match) active = panel;
    });

    // Hide the whole block when the active variant has no content.
    this.hidden = !active || active.textContent.trim() === '';
  }
}

if (!customElements.get('wi-variant-metafield')) {
  customElements.define('wi-variant-metafield', WIVariantMetafield);
}

export { WIVariantMetafield };
